import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { memo, useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import {
  WorkflowProgressPayload,
  WorkflowStage,
  WorkflowStageStatus,
} from './payloads';
import { useWidgetStyles } from './styles';

const stageLabels: Record<WorkflowStage, string> = {
  preInspection: '预检',
  inspection: '检测',
  quotation: '报价',
  construction: '施工',
  deliveryCheck: '交车检',
  settlement: '结算',
};

const stageColors: Record<WorkflowStageStatus, string> = {
  completed: '#22C55E',
  in_progress: '#3B82F6',
  pending: '#D1D5DB',
};

export const WorkflowProgressWidget = memo(
  ({ data }: { data: WorkflowProgressPayload }) => {
    const { rpx } = useResponsiveContext();
    const ws = useWidgetStyles();
    const s = useMemo(
      () =>
        StyleSheet.create({
          progressDot: {
            width: rpx(12),
            height: rpx(12),
            borderRadius: rpx(6),
          },
          progressLabel: {
            fontSize: rpx(10),
            fontFamily: FontFamily.NotoSans.Regular,
            color: '#64748B',
            marginTop: rpx(4),
          },
          progressLine: {
            height: rpx(2),
            flex: 1,
            marginHorizontal: rpx(-4),
            marginBottom: rpx(16),
          },
        }),
      [rpx],
    );

    const stages = Object.entries(data) as [
      WorkflowStage,
      WorkflowStageStatus,
    ][];

    return (
      <View style={ws.card}>
        <Text style={[ws.title, { marginBottom: rpx(8) }]}>工作流进度</Text>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          {stages.map(([stage, status], i) => (
            <React.Fragment key={stage}>
              <View style={{ alignItems: 'center', flex: 1 }}>
                <View
                  style={[
                    s.progressDot,
                    {
                      backgroundColor:
                        stageColors[status] ?? stageColors.pending,
                    },
                  ]}
                />
                <Text style={s.progressLabel}>
                  {stageLabels[stage] ?? stage}
                </Text>
              </View>
              {i < stages.length - 1 && (
                <View
                  style={[
                    s.progressLine,
                    {
                      backgroundColor:
                        status === 'completed' ? '#22C55E' : '#E5E7EB',
                    },
                  ]}
                />
              )}
            </React.Fragment>
          ))}
        </View>
      </View>
    );
  },
);
